import { useQuery } from '@tanstack/react-query';
import { graphQlClient } from '@config/graphqlClient';
import IncidentsGraphQL from '@graphql/incident.queries';
import { Incident } from '@models/incident.model';

export const INCIDENTS_BY_PROJECT_QUERY_KEY = 'incidents-by-project';

/**
 * Sprint 43, story-224. Incidents of one project (server order: newest first). The server gates
 * this read for a CLIENT on the checklist's `incidents` key and on project visibility, so a
 * caller with the key OFF simply gets `[]`. `enabled` (default true) lets the CLIENT project page
 * mount it only while the Incidents tab is the one on screen.
 */
export const useIncidentsByProject = (
  projectId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) =>
  useQuery<Incident[], Error>({
    queryKey: [INCIDENTS_BY_PROJECT_QUERY_KEY, projectId],
    queryFn: async () => {
      const data: any = await graphQlClient.request(
        IncidentsGraphQL.queries.getIncidentsByProject,
        { projectId },
      );
      return (data?.getIncidentsByProject ?? []) as Incident[];
    },
    enabled: enabled && !!projectId,
    staleTime: 30_000,
  });

export default useIncidentsByProject;
